import * as XLSX from "xlsx";

export const exportExcel = async (columns, rows, name) => {
  const data = [columns].concat(rows);
  const ws = XLSX.utils.aoa_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFileXLSX(wb, `${name}.xlsx`);
};

export const exportNominaToExcel = async (
  columns,
  rows,
  name,
  paymentForm,
  arrayOfSummariesToExport,
  company
) => {
  const data = [columns].concat(rows);

  let arrayOfArray = [
    ["", "", "", "", "", "", "", "", "", "", company],
    ["", "", "", "", "", "", "", "", "", "", "Reporte de Nomina"],
    ["", "", "", "", "", "", "", "", "", "", name],
    ["", "", "", "", "", "", "", "", "", "", "valor en RD$"],
    ["", "", "", "", "", "", "", "", "", "", `Pagado en ${paymentForm}`],
    [""],
    [""],
    [""],
    ...data,
    arrayOfSummariesToExport,
    [""],
    [""],
    [""],
    [""],
    [""],
    [
      "",
      "",
      "",
      "",
      "",
      "realizado por",
      null,
      "",
      "",
      "",
      "",
      "Revisado por",
      null,
      "",
      "",
      "",
      "",
      "Aprovado por"
    ]
  ];

  const ws = XLSX.utils.aoa_to_sheet(arrayOfArray);
  ws["!cols"] = fitToColumn(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFileXLSX(wb, `${name}.xlsx`);
};

function fitToColumn(arrayOfArray) {
  // get maximum character of each column
  return arrayOfArray[0].map((a, i) => ({
    wch: Math.max(
      ...arrayOfArray.map((a2) => (a2[i] ? a2[i].toString().length : 0))
    )
  }));
}
